export const SET_ORGANIZATIONS = (state, payload) => {
  state.total = payload.count;
  state.organizations = payload.results;
}

export const SET_ORGANIZATION = (state, payload) => {
  state.organization = payload;
}

export const SET_COLLECTIONS = (state, payload) => {
  state.collections = payload
}

export const SET_TEMPLATES = (state, payload) => {
  state.templates = payload
}